import React, { useContext } from 'react';

import LabelWithIcon from './LabelWithIcon';
import type { PromotionConfig, PromotionPriceArea } from '../../types';
import { CardsContext } from '../../../SearchPageContainer/ListContainer/CardsGrid/CardsContext';

type BadgesProps = {
  promotion: PromotionConfig;
};

const Badges = ({ promotion }: BadgesProps) => {
  const { isWaiting } = useContext(CardsContext);
  const promotionType = promotion?.promotionType;
  const icon = promotion?.icon;
  const text = promotion?.text;
  const className = promotion?.className;
  const callback = (promotion as PromotionPriceArea)?.callback;
  const Element = promotion?.Element;

  if (isWaiting || !promotionType) {
    return null;
  }

  const handleCallback = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    if (callback) callback();
  };

  if (Element) return <Element />;

  return promotionType ? (
    <LabelWithIcon
      label={text}
      promotionType={promotionType}
      {...(icon ? { icon } : {})}
      {...(className ? { className } : {})}
      {...(callback ? { callback: handleCallback } : {})}
    />
  ) : null;
};

export default Badges;
